import { render } from "./CotpGroupComponent.vue?vue&type=template&id=793da4fa&scoped=true"
import script from "./CotpGroupComponent.vue?vue&type=script&lang=js"
export * from "./CotpGroupComponent.vue?vue&type=script&lang=js"

import "./CotpGroupComponent.vue?vue&type=style&index=0&id=793da4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793da4fa"]])

export default __exports__